export const css = {
	root: '_33PucXl-',
	scoreContainer: '_3T7VSeMQ',
	title: '_2IvNZ-PC',
	wrapper: '_2WEOlhSL',
	domain: '_1K73W9So',
	field: '_2pkmF7TG',
	bar: '_2ef_-y-d',
	lowScore: 'yA7el3Uj',
	midScore: '_3kPtPbSA',
	highScore: '_1-czfBEv',
	barZero: '_2WRhJU_K',
	barLow: '_2my83tr0',
	barMid: '_3IDEGzX0',
	barHigh: 'GjAFjqX9',
	barscore: '-wK-N5yH',
	legend: '_2L6tgLLv',
	' _key': 'ascm-theme/ascm/prepost-viz/progress-viz'
};

export default css;
